import { createFileRoute } from "@tanstack/react-router";

import TenantsPage from "@/features/dashboard/pages/tenants";

export const Route = createFileRoute("/(app)/ops/organisations/")({
  component: () => <TenantsPage />,
});
